import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import HomeRealEstateAgentFormImg from '../assets/images/home-real-estate-agent-form-img.png'
import { CONTACT_AN_AGENT } from "../api/constants";
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
  
const HomeRealEstateAgentForm = ({ property }) => {
  const {id} = useParams();
const handleSubmit = async (e) => {
  e.preventDefault();

  // Convert form fields to JSON
  const formData = new FormData(e.target);
  const jsonData = Object.fromEntries(formData.entries());

  // Add inquiry_type explicitly
  if (id) {
    jsonData.inquiry_type = 'property';
    jsonData.property_id = id;
  } else {  
    jsonData.inquiry_type = 'general';
  }

  //get agent id from property if exists
  if (property && property.agent_id) {
    jsonData.agent_id = property.agent_id;
  }

  // Optional: normalize booleans
  jsonData.wants_financing_info = jsonData.wants_financing_info === 'on';
  jsonData.sms_consent = jsonData.sms_consent === 'on';

  try {
    const res = await fetch(CONTACT_AN_AGENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(jsonData)
    });

    const data = await res.json();

    if (data.status) {
      //clear form
      e.target.reset();
      Swal.fire({
        title: 'Success!',
        text: data.message,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#0abab5'
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: data.message || "Something went wrong",
        icon: 'error'
      });
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire({
      title: 'Error',
      text: "Failed to submit inquiry",
      icon: 'error'
    });
  }
};


  return (
    <div className="home-real-estate-agent common-padding">
      <Container>
        <Row>
          {/* Left Image */}
          <Col lg={6}>
            <img
              src={HomeRealEstateAgentFormImg}
              alt="Living Room"
              className="h-100 w-100 d-none d-lg-block"
            />
          </Col>

          {/* Right Form Section */}
          <Col lg={6}>
            <div className="form-wrap">
              <div className="common-header">
                <h2> Talk to a Real Estate Agent</h2>
                <p>You’ll be connected with an expert local agent—there’s no pressure or obligation.</p>
              </div>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Label>
                      First Name <span>*</span>
                    </Form.Label>
                    <Form.Control name="first_name" type="text" placeholder="Ex. John" />
                  </Col>
                  <Col md={6}>
                    <Form.Label>
                      Last Name <span>*</span>
                    </Form.Label>
                    <Form.Control name="last_name" type="text" placeholder="Ex. Doe" />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Label>
                      Email <span>*</span>
                    </Form.Label>
                    <Form.Control name="email" type="email" placeholder="Ex. xyz@domain.com" />
                  </Col>
                  <Col md={6}>
                    <Form.Label>
                      Phone <span>*</span>
                    </Form.Label>
                    <Form.Control name="phone" type="text" placeholder="Ex. +19876543210" />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col md={6}>
                    <Form.Label>
                      Property Type <span>*</span>
                    </Form.Label>
                    <Form.Select name="property_type">
                      <option>Select Type</option>
                      <option value="apartment">Apartment</option>
                      <option value="villa">Villa</option>
                      <option value="commercial">Commercial</option>
                      <option value="land">Land</option>
                    </Form.Select>
                  </Col>
                  <Col md={6}>
                    <Form.Label>
                      I Want <span>*</span>
                    </Form.Label>
                    <Form.Select name="intent">
                      <option value="buy">Buy</option>
                      <option value="sell">Sell</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Label>
                    What can we help you with?{" "}
                    <span>*</span>
                  </Form.Label>
                  <Form.Control
                    name="message"
                    as="textarea"
                    rows={3}
                    placeholder="Write here..."
                  />
                </Form.Group>

                <Form.Check 
                  type="checkbox"
                  name="wants_financing_info"
                  id="financeInfo"
                  label="I want financing information."
                  className='custom-checkbox mb-4'
                />

                <Button
                  type="submit"
                  className="custom-bttn style-1"
                >
                  Submit
                </Button>

                <p className="note">
                  By submitting this form, I agree to receive calls and SMS
                  messages from Redfin for the purpose of updates and promotions.
                  Messages may be sent on a recurring basis and frequency will
                  vary. Message and data rates may apply. Consent to receive SMS
                  messages is not required as a condition for purchasing any goods
                  or services. To unsubscribe from SMS messages, reply “STOP” at
                  any time. For assistance, reply “HELP” or visit redfin.com. By
                  proceeding, you confirm that you are creating a Redfin account
                  and have read and agree to our Privacy Policy and Terms of Use.
                </p>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomeRealEstateAgentForm;
